import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { useFeature } from '@growthbook/growthbook-react'
import cx from 'classnames'

import { ROUTE_PATH } from 'lib/paths'
import { endpoints } from 'store/api/yay/user'
import { selectIsLoggedIn } from 'store/selectors'
import { useIsSelfUser } from '../../lib/useIsSelfUser'
import useChatRoomLogic from 'features/Chat/hocs/useChatRoomLogic'

import FollowButton from 'features/User/components/FollowButton'
import Button from 'components/Button'

type Props = {
  followCallback: () => void
  createLetterModalLink: string
}

const UserActions = ({ followCallback, createLetterModalLink }: Props) => {
  const params = useParams()

  const { onCreateChatRoom, onCreateChatRoomIsLoading } = useChatRoomLogic()

  const userRes = endpoints?.getUser?.useQueryState?.({
    userId: params?.userId,
  })

  const user = userRes?.data

  const isSelfUser = useIsSelfUser(user?.id)
  const isLoggedIn = useSelector(selectIsLoggedIn)

  const isEmplGiftsEnabled = useFeature('yay-17610')?.on

  const show = isLoggedIn && !isSelfUser && typeof user?.id !== 'undefined'

  if (!show) return null

  return (
    <ul
      className={cx('User__profile__buttons', {
        'User__profile__buttons--other': !isSelfUser,
      })}
    >
      {isEmplGiftsEnabled && !isSelfUser && (
        <li>
          <Button
            icon="gift"
            buttonStyle="bordered-primary-without-bg"
            className="User__profile__gift"
            to={`${ROUTE_PATH.USER_GIFTS(user?.id)}?sendGift=true`}
          >
            {(user?.total_gifts_received_count ?? '').toLocaleString()}
          </Button>
        </li>
      )}
      <li>
        <Button
          buttonStyle={'bordered-primary-without-bg'}
          icon={'chat-pink'}
          loading={onCreateChatRoomIsLoading}
          onClick={() =>
            onCreateChatRoom({
              userIds: [user?.id],
              from: 'profile',
            })
          }
        />
      </li>
      <li>
        <FollowButton
          user={user}
          followCallback={followCallback}
          confirmBeforeUnfollow
          from="profile"
        />
      </li>
    </ul>
  )
}

export default UserActions
